import React from 'react'
import { useTestContext } from './TestContext'
import { TestListLoading } from '../loading/TestListLoading'

const TasksSection: React.FC = () => {
  const {
    tasks,
    isTestLoading,
    handleOpenModal,
    handleMarkAsComplete,
    handleMarkAsIncomplete,
    handleRemoveTask,
    currentUser,
  } = useTestContext()

  return (
    <div className='card px-6 mt-4'>
      {/* begin::Table container */}
      <div className='my-4 d-flex justify-content-between'>
        <div className='my-4'>
          <div className='fs-6 fw-bold mb-2'>Task List</div>
          <span>Assign tasks that might fix this test to team members.</span>
        </div>
        <button
          onClick={handleOpenModal}
          className='btn btn-sm fs-6'
          onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
            (e.currentTarget.style.backgroundColor = '#148363')
          }
          onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
            (e.currentTarget.style.backgroundColor = '#0E9F6E')
          }
          disabled={currentUser?.role === 'Auditor'}
          style={{
            backgroundColor: '#0E9F6E',
            color: '#fff',
            height: '40px',
            transition: 'background-color 0.3s',
          }}
        >
          Add Task
        </button>
      </div>
      <div
        className='table-responsive'
        style={{minHeight: '300px', maxHeight: '500px', overflowY: 'auto'}}
      >
        {/* begin::Table */}
        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
          {/* begin::Table head */}
          <thead>
            <tr className='fw-bold text-muted'>
              <th className='w-25px'></th>
              <th className='min-w-200px'>Task Name</th>
              <th className='min-w-50px'>Priority</th>
              <th className='min-w-100px'>Assigned To</th>
              <th className='min-w-50px text-end'></th>
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody>
            {isTestLoading ? (
              <TestListLoading />
            ) : tasks && tasks.length > 0 ? (
              tasks.map((task) => (
                <tr key={task.id}>
                  <td>
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input widget-9-check'
                        type='checkbox'
                        checked={task.status === 'Completed'}
                        onChange={() => {
                          if (task.status === 'Completed') {
                            handleMarkAsIncomplete(task.id, task.task_name)
                          } else {
                            handleMarkAsComplete(task.id, task.task_name)
                          }
                        }}
                      />
                    </div>
                  </td>

                  <td>
                    <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                      {task.task_name}
                    </div>
                  </td>

                  <td>
                    <a
                      href='#'
                      className={`badge fs-7 ${
                        task.priority === 'High'
                          ? 'badge-danger'
                          : task.priority === 'Medium'
                          ? 'badge-warning'
                          : 'badge-primary'
                      }`}
                      style={{
                        color:
                          task.priority === 'High'
                            ? '#EE3043'
                            : task.priority === 'Medium'
                            ? '#FFA800'
                            : '#0E9F6E',
                        background:
                          task.priority === 'High'
                            ? '#FFF5F8'
                            : task.priority === 'Medium'
                            ? '#FFF8DD'
                            : '#E8F8F4',
                      }}
                    >
                      {task.priority}
                    </a>
                  </td>
                  <td>
                    <div className='d-flex align-items-center'>
                      {task.owner ? (
                        <>
                          <div className='symbol symbol-35px me-3'>
                            <span
                              className='symbol-label fs-7 fw-bold'
                              style={{backgroundColor: '#DAF9EF'}}
                            >
                              {task.owner
                                ? (() => {
                                    const nameParts = task.owner.split(' ')
                                    if (nameParts.length > 1) {
                                      return `${nameParts[0]
                                        .charAt(0)
                                        .toUpperCase()}${nameParts[1]
                                        .charAt(0)
                                        .toUpperCase()}`
                                    } else {
                                      return `${nameParts[0]
                                        .charAt(0)
                                        .toUpperCase()}${nameParts[0]
                                        .charAt(1)
                                        .toUpperCase()}`
                                    }
                                  })()
                                : ''}
                            </span>
                          </div>
                          <div className='d-flex justify-content-start flex-column'>
                            <div className='text-dark fw-semibold text-hover-primary fs-6'>
                              {task.owner}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <span>-</span>
                        </>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className='d-flex justify-content-end flex-shrink-0'>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        onClick={() => handleRemoveTask(task.id)}
                        disabled={currentUser?.role === 'Auditor'}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='#F15363'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                        >
                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                          <path d='M4 7l16 0' />
                          <path d='M10 11l0 6' />
                          <path d='M14 11l0 6' />
                          <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                          <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className='text-center py-5'>
                  <img
                    src='/media/illustrations/empty.svg'
                    alt='No tasks'
                    className='mw-100 mh-200px mb-4'
                  />
                  <div className='fs-6'>
                    <p style={{fontWeight: 'bold'}}>No tasks added yet!!</p>
                  </div>
                  <p className='fs-7'>
                    Maybe try adding new tasks for this test
                  </p>
                </td>
              </tr>
            )}
          </tbody>
          {/* end::Table body */}
        </table>
        {/* end::Table */}
      </div>
      {/* end::Table container */}
    </div>
  )
}

export default TasksSection